module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/new/assessment_achievements/4@2x_28963d1f10c63f15541991af38ab79e5.png";